import React, { useState, useEffect } from 'react';
import RenderizarProduto from '../Utils/RenderizarProduto';
import AOS from "aos";
import 'aos/dist/aos.css';
import ActionButtonCard from '../Button/ActionButtonCard'
import { Row, Col, Table, Card, Form, Button, Spinner } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';

import BalancoDiario from './BalancoDiario'
import GraficoLinha from './BalancoBarras'
import GraficoCategorias from './BarrasCategorias'
import { useProvider, Toast } from '../../context/MenuProvider';


const Home = () => {
  const { id, tipo, categoria, modelo } = useParams();
  const { 
      crud,
      hasPerms,
      auth,
      buscarDados,
      salvarDados,
  } = useProvider();
  const navigate = useNavigate();
  
  const [empresa, setEmpresa] = useState(auth?.empresa);
  const [categorias, setCategorias] = useState([]);
  const [nextUrl, setNextUrl] = useState(null);
  const [query, setQuery] = useState('');
  const { get, loading } = crud || {};
  

  useEffect(() => {
    const buscar = async()=>{
      //buscarCategorias(true);
      buscarCategoriasLocal();
    }
    buscar();
  }, [tipo]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
        if (!loading) buscarCategorias();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, nextUrl]);
  
  const processTipo = (input) => {
    if (!input) return ""; // se vazio, retorna string vazia
  
    // garante array de itens sem espaços vazios
    let itens = (typeof input === "string" ? input : input.join(","))
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  
    if (itens.includes("pessoais") && !hasPerms(["financas.view_financeiro"])) {
      itens = itens.filter(i => i !== "pessoais");
    }
    if (itens.includes("negocio") && !hasPerms(["loja.view_venda"])) {
      itens = itens.filter(i => i !== "negocio");
    }
    if (itens.includes("produtos") && !hasPerms(["loja.view_produtos"])) {
      itens = itens.filter(i => i !== "produtos");
    }
    if (itens.includes("venda") && !hasPerms(["loja.view_venda"])) {
      itens = itens.filter(i => i !== "venda");
    }
    if (itens.includes("rede") && !hasPerms(["rede.view_prospecto","rede.view_consultor", "rede.view_apn"])) {
      itens = itens.filter(i => i !== "rede");
    }
  
    return itens.join(",");
  };  
  const tipos_destaque = processTipo("pessoais,negocio,venda,produtos,rede");
  const tipos = processTipo(tipo);
  
  const buscarCategoriasLocal = async () => {
    try{
      const array_tipos = tipos.split(",") || [];
      const array_tipos_destaques = tipos_destaque.split(",") || [];
      //alert(array_tipos_destaques)
      const response = await buscarDados(
        "db_categorias",
        (item) => {
          return tipos.length > 0 ? array_tipos?.includes(item.tipo) : item.is_destaque && array_tipos_destaques.includes(item.tipo)
        },
        20,
        "nome_da_categoria"
      )
      if(response && response.length){
        setCategorias(response);
      }
    }catch{
      
    }finally{
      buscarCategorias(true);
    }
  }

  const buscarCategorias = async (novaBusca = false) => {
    let url = `/gvendas/categorias/?expand=categoria_pai&ordering=nome_da_categoria`;
    if (tipo) url += `&tipo__in=${tipos}&ordering=nome_da_categoria`;
    if (!tipo) url += `&is_destaque=true&tipo__in=${tipos_destaque}&ordering=tipo`;
    if (query) url += `&search=${query}`;
    if (novaBusca) {
      //setCategorias([]);
      setNextUrl(null);
    } else if (nextUrl) {
      url = nextUrl;
    } else {
      url = null;
    }

    if (!url) return;

    try {
      const response = await get(url, 'relatorio');
      if (response && response.length) {
        const novosItens = response[0].results;
        setCategorias((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
        setNextUrl(response[0].next);
        await salvarDados("db_categorias", novosItens);
      }
    } catch (err) {
      //alert(JSON.stringify(err.response));
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  
  const categoriasGrupo = categorias.reduce((acc, item) => {
    const data = item.tipo;
    if (!acc[data]) {
      acc[data] = [];
    }
    acc[data].push(item);
    return acc;
  }, {});

  const BackupGoogle = async () => {
    try {
      if (loading) return;
      const response = await get(`/gvendas/empresas/${empresa.id}/backup/?expand=juros,configuracoes`, 'google');
      if (response) {
        Toast.fire({
          icon: "success",
          title: "Backup realizado com sucesso"
        });
      }
    } catch (err) { }
  };

  return (
    <>
      <div className="mb-3" data-aos="fade-up">
        <div className="d-flex flex-nowrap overflow-auto">
          {/* Destaques */}
          <ActionButtonCard 
            col="col-4 mx-1"
            icon="bx bx-star" 
            text="Destaques" 
            onClick={()=>navigate("/relatorios", {replace:true})}
          />
      
          {/* Rede */}
          {hasPerms(["rede.view_prospecto","rede.view_consultor","rede.view_apn"]) && (
            <ActionButtonCard 
              col="col-4 mx-1"
              icon="bx bx-sitemap" 
              text="Rede" 
              onClick={()=>navigate("/relatorios/rede", {replace:true})}
            />
          )}
      
          {/* Vendas */}
          {hasPerms(["loja.view_venda"]) && (
            <ActionButtonCard 
              delay={100}
              col="col-4 mx-1"
              icon="bx bx-shopping-bag" 
              text="Vendas" 
              onClick={()=>navigate("/relatorios/venda", {replace:true})}
            />
          )}
      
          {/* Produtos */}
          {hasPerms(["loja.view_produtos"]) && (
            <ActionButtonCard 
              delay={200}
              col="col-4 mx-1"
              icon="bx bx-package" 
              text="Produtos" 
              onClick={()=>navigate("/relatorios/produtos", {replace:true})}
            />
          )}
      
          {/* Pessoais */}
          {hasPerms(["financas.view_financeiro"]) && (
            <ActionButtonCard 
              delay={300}
              col="col-4 mx-1"
              icon="bx bx-user-pin" 
              text="Pessoais" 
              onClick={()=>navigate("/relatorios/pessoais", {replace:true})}
            />
          )}
      
          {/* Negócio */}
          {hasPerms(["loja.view_venda"]) && (
            <ActionButtonCard 
              delay={400}
              col="col-4 mx-1"
              icon="bx bx-store-alt" 
              text="Negócio" 
              onClick={()=>navigate("/relatorios/negocio", {replace:true})}
            />
          )}
        </div>
      </div>
      
      {(tipo && modelo!==`barras-categorias`) && (<>
        <Button size="sm" className="mb-2" onClick={()=>navigate(`/relatorios/${tipo}/barras-categorias`)} variant="outline-secondary">
          Gráfico Barras Geral
        </Button>
      </>)}
      {(categoria && modelo===`balanco`) && <BalancoDiario/>}
      {(categoria && modelo===`barras`) && <GraficoLinha/>}
      {(tipo && modelo===`barras-categorias`) && <GraficoCategorias/>}
      

      {!modelo && (<>
        <div className="list-group">
          {categorias?.map((x, index) => (
              <div
                key={x.id}
                //data-aos="fade-up"
                className="mb-1"
                //data-aos-delay={parseInt(`${index}00`)}
              >
                <RenderizarProduto
                  //icon="bi-cash-stack"
                  col="d-none"
                  text1={(<>
                    {x.tipo_text}
                    {x.categoria_pai && (<>
                      {' - '} 
                      {x.categoria_pai?.nome}
                    </>)}
                  </>)}
                  titulo={x.nome}
                  text2={x.descricao}
                  extra={(<>
                    <Row>
                      <Col className="text-end">
                        <Button size="sm" className="ms-2" onClick={()=>navigate(`/relatorios/${x.tipo}/${x.id}/balanco`)} variant="outline-secondary">
                          Balanço Diário
                        </Button>
                        <Button size="sm" className="ms-2" onClick={()=>navigate(`/relatorios/${x.tipo}/${x.id}/barras`)} variant="outline-secondary">
                          Gráfico de Barras
                        </Button>
                      </Col>
                    </Row>
                  </>)}
                />
              </div>
          ))}
          {!categorias && (
            !loading && <p data-aos="fade-up" className="text-center text-muted">Nenhum relatório encontrado.</p>
          )}
          {tipo === "backup" && (<>
            <small className="text-muted mt-4" data-aos-delay={400} data-aos="fade-up">
              Receber backup completo dos seus dados na planilha google
            </small>
            <div data-aos="fade-up" data-aos-delay={500}>
              <RenderizarProduto
                onClick={() => BackupGoogle()}
                icon="bi-cloud-upload"
                titulo={`Planilha backup ${loading ? '(aguarde...)' : ''}`}
                text2="backup da base de dados em planilha google"
              />
            </div>
            {empresa?.link_planilha && (
              <div data-aos="fade-up" data-aos-delay={600}>
                <RenderizarProduto
                  onClick={() => window.open(empresa.link_planilha)}
                  icon="bi-file-spreadsheet"
                  titulo="Acessar Planilha"
                  text2="Abrir Planilha de Backup"
                />
              </div>
            )}
          </>)}
        </div>
      </>)}
    </>
  );
};

export default Home;